class BESSAppProjectEditorModal extends BESSAppModal {

    constructor(profiler, fullscreen = true) {
        super('app-editor-modal');
        if (fullscreen) {
            this.view.node.find('.modal-dialog').addClass('modal-fullscreen').removeClass('modal-natural');
            this.view.node.find('.modal-footer').addClass('d-lg-none');
        } else {
            this.view.node.find('.modal-dialog').removeClass('modal-fullscreen').addClass('modal-natural');
            this.view.node.find('.modal-footer').removeClass('d-lg-none');
        }

        this.view.cancelButton = this.view.node.find('.app-action-cancel');
        this.view.closeButton = this.view.node.find('.app-action-close');
        this.view.saveButton = this.view.node.find('.app-action-save');
        this.view.addButton = this.view.node.find('.app-action-add-new');

        this.view.addButton.hideIf(!profiler.data.allowCreateDeleteItems);
        this.view.addButton.text('Add ' + profiler.data.what);

        this.view.cancelButton.bindClickEvent(this, this.#onCancelEditor);
        this.view.closeButton.bindClickEvent(this, this.close);
        this.view.saveButton.bindClickEvent(this, this.#onSaveEditor);
        this.view.addButton.bindClickEvent(this, this.#onAddItem);

        this.view.saveButton.find('span').text('Save');
        this.view.cancelButton.find('span').text('Cancel');

        this.editor = new BESSAppProjectEditor(
            this.view.node,
            profiler.data,
            this.#updateActionButtonState.bind(this));

        this.editorFilter = new BESSAppProjectEditorFilters(
            this.view.node.find('.app-filters'),
            this.editor,
        );
        this.setTitle(profiler.title);
        this.#updateActionButtonState();
    }


    open(onShownFn = null) {
        this.editorFilter.reset();
        super.open(onShownFn);
    }

    openAndAddNewItem() {
        this.editorFilter.reset();
        this.open(function () {
            this.editor.addNewItem();
        });
    }

    openAndEditItem(item) {
        this.editorFilter.reset();
        this.open(function () {
            this.editor.startEditing(item);
        }.bind(this));
    }


    #onCancelEditor() {
        this.askUserToConfirm(
            "Cancel",
            "Discard all your changes made here?",
            this.close.bind(this),
            "Yes - discard changes",
            "No - continue editing"
        );
    }

    close() {
        super.close();
        this.view.node.removeClass('app-with-validation-issues');

    }

    #onSaveEditor() {
        this.editorFilter.undo();
        this.view.cancelButton.disableControl()
        this.view.saveButton.startSaving();
        this.view.node.removeClass('app-with-validation-issues');
        this.editor.saveEdits(function () {
                this.close();
                this.view.node.removeClass('app-with-validation-issues');
                this.view.cancelButton.enableControl();
                this.view.saveButton.endSaving();
            }.bind(this),
            function () {
                this.view.node.addClass('app-with-validation-issues');
                this.view.cancelButton.enableControl();
                this.view.saveButton.endSaving();
            }.bind(this));
    }

    #onAddItem() {
        this.editor.addNewItem();
    }

    #updateActionButtonState() {
        if (this.editor === undefined) return;
        let editorChangesHaveBeenMade = this.editor.hasChanges;
        //let ableToSave = this.editor.manager == null || this.editor.manager.isValid();
        this.view.saveButton.enableIf(editorChangesHaveBeenMade);
        this.view.closeButton.hideIf(editorChangesHaveBeenMade);
        this.view.cancelButton.showIf(editorChangesHaveBeenMade);
        this.editorFilter.updateState();
    }
}